// extracted by mini-css-extract-plugin
module.exports = {"breadcrumbs":"Layout_breadcrumbs__Q1pcy","header-text":"Layout_header-text__1jREM"};